import { render, staticRenderFns } from "./MyTravel.vue?vue&type=template&id=78cbb658&scoped=true"
import script from "./MyTravel.vue?vue&type=script&lang=js"
export * from "./MyTravel.vue?vue&type=script&lang=js"
import style0 from "./MyTravel.vue?vue&type=style&index=0&id=78cbb658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cbb658",
  null
  
)

export default component.exports